// extracted by mini-css-extract-plugin
module.exports = {"component":"module-loading-fallback_component__PgGMa","skeletonLoader":"module-loading-fallback_skeletonLoader__yoeO7"};